import { render } from "./Game.vue?vue&type=template&id=7453c9c8"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"

import "./Game.vue?vue&type=style&index=0&id=7453c9c8&lang=css"
script.render = render

export default script